define.alias("shared/components/shared/address-fields", "calendar/components/shared/address-fields");